import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchRole, createRole, updateRole } from './actions';
import RoleSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleRoleSettingsSubmit = this.handleRoleSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchRole } = this.props;
		const roleId = match.params.id;

		if (roleId) {
			fetchRole(roleId);
		}
	}

	handleRoleSettingsSubmit(values) {
		const { role, createRole, updateRole, history } = this.props;

		if (role) {
			updateRole(role.id, values);
		} else {
			createRole(values, history);
		}
	}

	render() {
		const { role, isReadonly, t } = this.props;
		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<RoleSettingsForm isReadonly={isReadonly} onSubmit={this.handleRoleSettingsSubmit} initialValues={role} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const roleId = ownProps.match.params.id;

	const {
		entities: { roles },
		auth: { currentUser }
	} = state;

	return {
		role: roles[roleId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'UserRoles')
	};
};

export default connect(mapStateToProps, {
	fetchRole,
	createRole,
	updateRole
})(withTranslation()(Details));